<template>
  <v-card class="mb-3">
    <v-list-item>
      <v-list-item-content>
        {{$t('couponInput_title1')}}
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <div class="px-4 area__sty">
      <div class="my-n1 area__radio__sty" v-if="isOnlyCoupon">
        <p class="subsubtitle__sty alert__sty">※{{$t('couponInput_text3')}}</p>
        <v-radio-group v-model="CouponStarradioGroup" @change="onCouponStarTypeChange($event)">
          <v-radio
            v-for="(item, idx) in CouponStarType"
            :key="'A' + idx"
            :label="item.name"
            :value="item.value"
            class="radio__sty"
          ></v-radio>
        </v-radio-group>
      </div>
      <!-- 不可使用星幣 -->
      <div class="my-n1 area__radio__sty" v-else>
        <v-radio-group v-model="CouponStarradioGroup" @change="onCouponStarTypeChange($event)">
          <v-radio
            v-for="(item, idx) in CouponType"
            :key="'A' + idx"
            :label="item.name"
            :value="item.value"
            class="radio__sty"
          ></v-radio>
        </v-radio-group>
      </div>
      <!-- 折價券: 1 星幣: 2 購物金: 3 -->
      <div v-show="CouponStarradioGroup === 2" class="subsub__area__sty">
        <span class="subsubtitle__sty">{{$t('couponInput_text1_1')}}{{ this.$store.state.starpoint.starpointData.user_star_point }}{{$t('couponInput_text1_2')}}{{ this.$store.state.starpoint.starpointData.user_star_point }} ({{$t('couponInput_text1_3')}}{{ this.$store.state.starpoint.starpointData.product_star_point*this.$store.state.shoplist.shoplistData[0].num_selection*this.$store.state.shoplist.shoplistData[0].num_selection_specname }}{{$t('couponInput_text1_4')}})</span>
        <v-row no-gutters class="mt-3">
          <v-col cols="9" class="pr-2">
            <v-text-field
              :placeholder="$t('couponInput_input1')"
              outlined
              dense
              v-model="use_star_point"
              type="number"
              class="input__sty"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="btn__sty">
            <v-btn
              v-if="show_send"
              depressed
              @click="usesCouponStarPoint()"
            >
              {{$t('couponInput_button1')}}
            </v-btn>
            <v-btn
              v-else
              depressed
              @click="usesCouponStarPoint()"
            >
              {{$t('couponInput_button2')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-show="CouponStarradioGroup === 1">
        <v-row no-gutters>
          <v-col cols="9" class="pr-2">
            <v-text-field
              :placeholder="$t('couponInput_input2')"
              outlined
              dense
              v-model="coupon_txt"
              class="input__sty"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="btn__sty">
            <v-btn
              v-if="show_send"
              depressed
              @click="usesCouponStarPoint()"
            >
              {{$t('couponInput_button1')}}
            </v-btn>
            <v-btn
              v-else
              depressed
              @click="usesCouponStarPoint()"
            >
              {{$t('couponInput_button2')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-show="CouponStarradioGroup === 3" class="pb-3 subsub__area__sty">
        <v-row no-gutters v-if="!showarea.moneycoupon">
          <v-col cols="9" class="pr-2">
            <v-text-field
              :placeholder="$t('couponInput_input3')"
              outlined
              dense
              v-model="use_shop_money"
              type="number"
              class="input__sty"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="btn__sty">
            <v-btn
              v-if="show_send"
              depressed
              @click="usesCouponStarPoint()"
            >
              {{$t('couponInput_button1')}}
            </v-btn>
            <v-btn
              v-else
              depressed
              @click="usesCouponStarPoint()"
            >
              {{$t('couponInput_button2')}}
            </v-btn>
          </v-col>
          <v-btn
            small
            depressed
            class="float-right white--text use__btn__sty"
            v-show="!showarea.moneycoupon"
            @click="showMoneyCoupon"
          >
            {{$t('couponInput_button3')}}
          </v-btn>
        </v-row>
        <v-row no-gutters v-else>
          <v-col cols="9" class="pr-2">
            <v-text-field
              :placeholder="$t('couponInput_input4')"
              outlined
              dense
              v-model="money_coupon"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="btn__sty">
            <v-btn
              depressed
              @click="UsesMoneyCoupon()"
            >
              {{$t('couponInput_button4')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'couponInput',

  data: function () {
    return {
      access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
      token: sessionStorage.getItem('accessToken'),
      user_uuid: sessionStorage.getItem('user_uuid'),
      group_uuid: sessionStorage.getItem('group_uuid'),
      coupon_txt: '',
      // 剩餘購物金
      balance: 0,
      use_star_point: 0,
      use_shop_money: 0,
      // 原始價格
      calprice: 0,
      show_send: true,
      product_id: 0,
      qty: 0,
      CouponStarradioGroup: 0,
      CouponStarType: [
        { 'name': this.$t('couponInput_input5'), 'value': 0, 'show': true },
        { 'name': this.$t('couponInput_input6'), 'value': 3, 'show': true},
        { 'name': this.$t('couponInput_input7'), 'value': 1, 'show': true},
        { 'name': this.$t('couponInput_input8'), 'value': 2, 'show': true }
      ],
      // 不可使用星幣折抵
      CouponType: [
        { 'name': this.$t('couponInput_input5'), 'value': 0, 'show': true },
        { 'name': this.$t('couponInput_input6'), 'value': 3, 'show': true},
        { 'name': this.$t('couponInput_input7'), 'value': 1, 'show': true}
      ],
      // 綁定購物金
      money_coupon: '',
      showarea: {
        moneycoupon: false
      }
    }
  },
  computed: {
    // 此商品可否用星幣
    isOnlyCoupon() {
      if (this.$store.state.starpoint.starpointData.product_star_point !== 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    // 使用優惠
    usesCouponStarPoint() {
      // 折價券: 1 星幣: 2 購物金: 3
      if (this.CouponStarradioGroup === 1) {
        if (this.coupon_txt !== '') {
          this.calprice = this.$store.state.shoplist.shoplistData[0].num_selection_calprice;
          this.product_id = this.$store.state.productinfo.productinfoData[0].product_id;
          this.qty = this.$store.state.shoplist.shoplistData[0].num_selection;
          this.$store.state.productinfo.productinfoData[0].coupon = this.coupon_txt;
          // 星幣還原
          this.use_star_point = 0;
          this.$store.state.productinfo.productinfoData[0].starpoint = 0;
          // 購物金還原
          this.use_shop_money = 0;
          this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
          this.axios({
            method: 'post',
            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v2/web-users/discount-price`,
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            data: {
              user_uuid: this.user_uuid,
              discount_type: this.CouponStarradioGroup,
              coupon: this.coupon_txt,
              use_cheer_point: parseInt(this.use_star_point),
              use_shop_money: parseInt(this.use_shop_money),
              production: {
                product_id: this.product_id,
                qty: this.qty,
                spec_id: this.$store.state.shoplist.shoplistData[0].num_selection_id,
              },
            },
          })
            .then((response) => {
              this.$store.state.shoplist.shoplistData[0].is_coupon_price = response.data.coupon_discount;
              this.$store.state.shoplist.shoplistData[0].is_star_price = response.data.point_discount;
              this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = response.data.shopmoney_discount;
              this.balance = response.data.balance;
              // 重新計算免運門檻
              if (response.data.price >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
                this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
              } else {
                this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
              }
              this.show_send = false;
            })
            .catch((error) => {
              this.coupon_txt = '';
              this.$store.state.productinfo.productinfoData[0].coupon = '';
              this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
              alert(error.response.data.message);
            });
        } else {
          alert('未輸入折價序號');
          this.$store.state.productinfo.productinfoData[0].coupon = '';
          this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
          return false;
        }
      } else if (this.CouponStarradioGroup === 2) {
        // 星幣使用上限
        const limit_use_star_point = this.$store.state.starpoint.starpointData.product_star_point*this.$store.state.shoplist.shoplistData[0].num_selection*this.$store.state.shoplist.shoplistData[0].num_selection_specname;
        if (this.use_star_point !== 0 && this.use_star_point <= limit_use_star_point) {
          this.calprice = this.$store.state.shoplist.shoplistData[0].num_selection_calprice;
          this.product_id = this.$store.state.productinfo.productinfoData[0].product_id;
          this.qty = this.$store.state.shoplist.shoplistData[0].num_selection;
          // 折價券還原
          this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
          this.$store.state.productinfo.productinfoData[0].coupon = '';
          // 購物金還原
          this.use_shop_money = 0;
          this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
          this.axios({
            method: 'post',
            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v2/web-users/discount-price`,
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            data: {
              user_uuid: this.user_uuid,
              discount_type: this.CouponStarradioGroup,
              coupon: this.coupon_txt,
              use_cheer_point: parseInt(this.use_star_point),
              use_shop_money: parseInt(this.use_shop_money),
              production: {
                product_id: this.product_id,
                qty: this.qty,
                spec_id: this.$store.state.shoplist.shoplistData[0].num_selection_id,
              },
            },
          })
            .then((response) => {
              this.$store.state.shoplist.shoplistData[0].is_coupon_price = response.data.coupon_discount;
              this.$store.state.shoplist.shoplistData[0].is_star_price = response.data.point_discount;
              this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = response.data.shopmoney_discount;
              this.balance = response.data.balance;
              // 重新計算免運門檻
              if (response.data.price >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
                this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
              } else {
                this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
              }
              this.show_send = false;
            })
            .catch((error) => {
              this.use_star_point = 0;
              this.$store.state.productinfo.productinfoData[0].starpoint = 0;
              this.$store.state.shoplist.shoplistData[0].is_star_price = 0;
              alert(error.response.data.message);
            });
        } else if (this.use_star_point > limit_use_star_point) {
          alert('星幣不可超過折扣上限');
          this.use_star_point = 0;
          this.$store.state.productinfo.productinfoData[0].starpoint = 0;
          this.$store.state.shoplist.shoplistData[0].is_star_price = 0;
          return false;
        } else {
          alert('未輸入星幣');
          this.$store.state.productinfo.productinfoData[0].starpoint = 0;
          this.$store.state.shoplist.shoplistData[0].is_star_price = 0;
          return false;
        }
      } else {
        // 購物金使用上限(可折抵運費)
        // const limit_use_shop_money = this.balance;
        // 總價
        console.log(this.$store.state.shoplist.shoplistData[0]);
        let price = 0;
        // 計算是否有運費
        if (parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_calprice >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree)) {
          price = parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_calprice);
        } else {
          price = parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_calprice+this.$store.state.shoplist.shoplistData[0].num_selection_fee);
        }
        if (this.use_shop_money !== 0 ) {
          if (parseInt(this.use_shop_money) <= price) {
            this.calprice = this.$store.state.shoplist.shoplistData[0].num_selection_calprice;
            this.product_id = this.$store.state.productinfo.productinfoData[0].product_id;
            this.qty = this.$store.state.shoplist.shoplistData[0].num_selection;
            this.use_star_point = 0;
            // 星幣還原
            this.$store.state.productinfo.productinfoData[0].starpoint = 0;
            this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
            // 折價券還原
            this.$store.state.productinfo.productinfoData[0].coupon = '';
            this.$store.state.productinfo.productinfoData[0].shopmoney = parseInt(this.use_shop_money);
            this.axios({
              method: 'post',
              url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v2/web-users/discount-price`,
              headers: {
                Authorization: `Bearer ${this.token}`
              },
              data: {
                user_uuid: this.user_uuid,
                discount_type: this.CouponStarradioGroup,
                coupon: this.coupon_txt,
                use_cheer_point: parseInt(this.use_star_point),
                use_shop_money: parseInt(this.use_shop_money),
                production: {
                  product_id: this.product_id,
                  qty: this.qty,
                  spec_id: this.$store.state.shoplist.shoplistData[0].num_selection_id,
                },
              },
            })
              .then((response) => {
                this.$store.state.shoplist.shoplistData[0].is_coupon_price = response.data.coupon_discount;
                this.$store.state.shoplist.shoplistData[0].is_star_price = response.data.point_discount;
                this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = response.data.shopmoney_discount;
                this.balance = response.data.balance;
                // 重新計算免運門檻
                // if (response.data.price >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
                //   this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
                // } else {
                //   this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
                // }
                this.show_send = false;
              })
              .catch((error) => {
                this.use_shop_money = 0;
                this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
                this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = 0;
                alert(error.response.data.message);
              });
          } else {
            alert('超過可用購物金限制');
            this.use_shop_money = 0;
            this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
            this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = 0;
          }
        } else {
          alert('未輸入購物金');
          this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
          this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = 0;
        }
      }
    },
    // 切換優惠
    onCouponStarTypeChange(e) {
      // 切換折扣
      this.$store.state.productinfo.productinfoData[0].usecostprice = this.CouponStarradioGroup;
      // 原始價格
      this.calprice = this.$store.state.shoplist.shoplistData[0].num_selection_calprice;
      // 折價券: 1 星幣: 2 購物金: 3
      if (e === 1) {
        // 星幣清除
        this.use_star_point = 0;
        this.$store.state.productinfo.productinfoData[0].starpoint = 0;
        this.$store.state.shoplist.shoplistData[0].is_star_price = 0;
        // 購物金清除
        this.use_shop_money = 0;
        this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
        this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = 0;
        // 重新計算免運門檻
        if (this.calprice >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
        } else {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
        }
        // 重新取可使用購物金
        this.getBalance();
      } else if (e === 2) {
        // 折價券清除
        this.coupon_txt = '';
        this.$store.state.productinfo.productinfoData[0].coupon = '';
        this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
        // 購物金清除
        this.use_shop_money = 0;
        this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
        this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = 0;
        // 重新計算免運門檻
        if (this.calprice >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
        } else {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
        }
        // 重新取可使用購物金
        this.getBalance();
      } else if (e === 3) {
        // 星幣清除
        this.use_star_point = 0;
        this.$store.state.productinfo.productinfoData[0].starpoint = 0;
        this.$store.state.shoplist.shoplistData[0].is_star_price = 0;
        // 折價券清除
        this.coupon_txt = '';
        this.$store.state.productinfo.productinfoData[0].coupon = '';
        this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
        // 重新計算免運門檻
        if (this.calprice >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
        } else {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
        }
      } else {
        // 星幣清除
        this.use_star_point = 0;
        this.$store.state.productinfo.productinfoData[0].starpoint = 0;
        this.$store.state.shoplist.shoplistData[0].is_star_price = 0;
        // 折價券清除
        this.coupon_txt = '';
        this.$store.state.productinfo.productinfoData[0].coupon = '';
        this.$store.state.shoplist.shoplistData[0].is_coupon_price = 0;
         // 購物金清除
        this.use_shop_money = 0;
        this.$store.state.productinfo.productinfoData[0].shopmoney = 0;
        this.$store.state.shoplist.shoplistData[0].is_shopmoney_price = 0;
        // 重新計算免運門檻
        if (this.calprice >= this.$store.state.shoplist.shoplistData[0].num_selection_shippingfree) {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = 0;
        } else {
          this.$store.state.shoplist.shoplistData[0].num_selection_fee = this.$store.state.shoplist.shoplistData[0].num_selection_oldfee;
        }
        // 重新取可使用購物金
        this.getBalance();
      }
    },
    // 取得購物金
    getBalance() {
      this.axios({
        method: 'post',
        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/get-shopmoney`,
        headers: {
            Authorization: `Bearer ${this.token}`
        },
        data: {
            user_uuid: this.user_uuid,
        },
      })
          .then((response) => {
              this.balance = response.data.balance;
              this.CouponStarType[1].name = `${this.$t('couponInput_input6')}NT$${this.balance}`;
              this.CouponType[1].name = `${this.$t('couponInput_input6')}NT$${this.balance}`;
          })
          .catch((error) => {
              alert(error.response.data.message);
          });
    },
    // 綁定購物金區塊
    showMoneyCoupon() {
      this.showarea.moneycoupon = true;
    },
    // 綁定購物金
    UsesMoneyCoupon() {
      if (this.money_coupon === '') {
          alert('未輸入購物金序號');
      } else {
          this.axios({
              method: 'post',
              url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/import-shopmoney`,
              headers: {
                  Authorization: `Bearer ${this.token}`
              },
              data: {
                  user_uuid: this.user_uuid,
                  coupon: this.money_coupon
              },
          })
              .then((response) => {
                  this.balance = response.data.balance;
                  this.money_coupon = '';
                  alert(response.data.message);
              })
              .catch((error) => {
                  alert(error.response.data.message);
              });
      }
      this.showarea.moneycoupon = false;
    }
  },
  mounted() {
    this.getBalance();
  },
  watch: {
  },
};
</script>

<style lang="sass">
    .input__sty .v-text-field__details, .input__sty .v-messages
        min-height: unset
</style>
<style lang="sass" >
  .use__btn__sty
    background: #352D40 !important
  .alert__sty
    color: #b80000
</style>
